export const WELCOME_MEDIA_URL = 'welcome_page/';
export const STORE_SWIRCHER_WELCOME_ID = 'WELCOME_STORE_WITCHER';
export const WELCOME_PAGE_CLASS = 'welcome-page';
